/* globals jQuery, document */

jQuery(document).ready(function($) {
  var mobileMenuOpen = false;
  // hamburger animates to x
  function toggleHamburger() {
    $('#nav-hamburger').toggleClass('open');
  }

  function openCloseMobileMenu() {
    if (mobileMenuOpen === false) {
      mobileMenuOpen = true;
    } else {
      mobileMenuOpen = false;
    }

    $('.overlay').toggleClass('open');
    $('.nav-wrapper').toggleClass('invert-menu');
    $('.nav-container')
        .delay(3000)
        .removeClass('shift-up');
    toggleHamburger();
  }

  // hamburger showing mobile nav when tapped
  $('#nav-hamburger, .overlay-close').click(function() {
    openCloseMobileMenu();
  });

  $('html').on('touchstart', function() {
    if (mobileMenuOpen === true) {
      openCloseMobileMenu();
    }
  });

  $('.overlay-slidedown, #nav-hamburger').on('touchstart', function(e) {
    e.stopPropagation();
  });
});
